import { VSelect } from 'vuetify/lib/components/VSelect';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(VSelect,{attrs:{"items":_vm.limits,"label":_vm.label,"value":_vm.currentLimit},on:{"change":_vm.setPaginationLimit}})}
var staticRenderFns = []

export { render, staticRenderFns }